import React, { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import UpdateIcon from '@mui/icons-material/Update'
import HttpsIcon from '@mui/icons-material/Https'
import axios from 'axios'

import {
  isOnline,
  updateData,
  getData,
  upsertDataTournaments,
} from '../../api/indexedDBHandler'

const UpdateOnline = ({
  id,
  responseTournaments,
  responseTeams,
  responseStage,
}) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    const handleOnline = () => setIsOnline(true)
    const handleOffline = () => setIsOnline(false)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  const cupstep = (idstep) => {
    const getTournaments = async () => {
      const results = await getData('user', 'created', true)
      const { value } = results[0]
      console.log(id)
      const response = await axios.post(
        'https://admin-protocarp.ru/php/tournaments/getTourID.php',
        {
          ...value,
          id: idstep,
        }
      )
      if (response.data.stage.items) {
        response.data.stage.id = idstep
        updateData('stage', idstep, response.data.stage)
      }
    }
    getTournaments()
  }
  const updateDataBt = () => {
    setLoading(true)
    try {
      const getTournaments = async () => {
        const results = await getData('user', 'created', true)
        const { value } = results[0]
        console.log(id)
        const response = await axios.post(
          'https://admin-protocarp.ru/php/tournaments/getTourID.php',
          {
            ...value,
            id: id,
          }
        )
        if (response.data.success) {
          setLoading(false)

          // setTournaments(response.data.tournaments)
          // setArchive(response.data.archive)

          if (response.data.tournaments.length > 0) {
            const filteredTournament = response.data.tournaments.filter(
              (e) => e && e.id === id
            )
            updateData('tournaments', id, filteredTournament[0])
            //  upsertDataTournaments('tournaments', response.data.tournaments)

            responseTournaments(filteredTournament[0])
            if (response.data.teams) {
              upsertDataTournaments('teams', response.data.teams)
              responseTeams(response.data.teams)
            }

            if (response.data.stage.items) {
              response.data.stage.id = id
              updateData('stage', id, response.data.stage)
              //upsertDataTournaments('teams', response.data.stage)
              responseStage(response.data.stage.items)
            }

            console.log('response', response.data)

            if (response.data.tournaments[0].count_cups > 1) {
              const stagesCupArray = JSON.parse(
                response.data.tournaments[0].stages_cup_id
              )
              for (const [index, item] of stagesCupArray.entries()) {
                if (item.id1 != id) {
                  cupstep(item.id1)
                }

                console.log('item', item)
              }
              console.log('stagesCupArray', stagesCupArray)
            }
          }
        } else if (response.data.error_code == 404) {
          setLoading(false)
          // setTournaments([])
          // setArchive([])
          // setError("Требуется авторизация");
          // setIsUserName(false);
          // localStorage.removeItem("user");
        } else {
          setLoading(false)
          // setArchive([])
          // setTournaments([])
        }
      }

      getTournaments()
    } catch (err) {
      alert(
        'Отсутствует соединение с интернетом. Данные взяты из памяти устройства.'
      )
    }
  }
  return (
    <>
      <Stack
        spacing={1}
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Typography variant="body1" gutterBottom>
            Обновить данные через интернет.
          </Typography>
        </div>
        <div>
          <Button
            variant="outlined"
            size="small"
            disabled={!isOnline || loading}
            onClick={updateDataBt}
            startIcon={
              !isOnline ? (
                <HttpsIcon style={{ color: 'red' }} />
              ) : (
                <UpdateIcon />
              )
            }
          >
            Обновить
          </Button>
        </div>
      </Stack>
    </>
  )
}
export default UpdateOnline
